module.exports = __webpack_public_path__ + "static/assets/e5f78a3872a727a3b942905b6eea95d1.png";